import { render, staticRenderFns } from "./EntryTable.vue?vue&type=template&id=2da15384&scoped=true&"
import script from "./EntryTable.vue?vue&type=script&lang=js&"
export * from "./EntryTable.vue?vue&type=script&lang=js&"
import style0 from "./EntryTable.vue?vue&type=style&index=0&id=2da15384&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da15384",
  null
  
)

export default component.exports